import Model, { attr } from '@ember-data/model';

export interface SyncedMergeField {
  name: string;
  tag: string;
  field_type: string;
  attribute: string;
}

export interface ApiMergeField {
  name: string;
  tag: string;
  type: string;
  required: boolean;
  options: any;
}

export default class MailchimpFundSyncModel extends Model {
  @attr('string') mailchimpAccountId!: string;
  @attr('string') fundId?: string;
  @attr('string') audienceId?: string;
  @attr('boolean') automaticallySyncFirstEmail?: boolean;
  @attr('boolean') automaticallySyncAllEmails?: boolean;
  @attr() syncedMergeFields?: SyncedMergeField[];
  @attr() apiMergeFields?: ApiMergeField[];
  @attr() groupsToSync?: string[];
  @attr('boolean') syncGroupsToTags?: boolean;
  @attr('boolean') syncGroupsToInterestCategory?: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'mailchimp-fund-sync': MailchimpFundSyncModel;
  }
}
